import { action } from 'typesafe-actions';
import { PaintsTypes } from '../types/paints.types';

export const getPaintsRequest = () => action(PaintsTypes.GET_REQUEST);

export const getPaintsSuccess = data => action(PaintsTypes.GET_SUCCESS, data);

export const getPaintsError = () => action(PaintsTypes.GET_FAILURE);
